module.exports = __webpack_public_path__ + "img/logo-3dm-mobile-red.d43cae34.svg";